import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject, signal } from "@angular/core";
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { TabConfig } from "@template-ui/types";

import { PhmsDetailNavBarService } from "../phms/navigation/phms-detail-nav-bar.service";
import { CaseContextSnapshotRailComponent } from "./components/case-context-snapshot-rail/case-context-snapshot-rail.component";
import { CaseContextActivityTabComponent } from "./components/case-context-tabs/case-context-activity-tab.component";
import { CaseContextDocumentsTabComponent } from "./components/case-context-tabs/case-context-documents-tab.component";
import { CaseContextLegalRecordsTabComponent } from "./components/case-context-tabs/case-context-legal-records-tab.component";

/**
 * Hearing-preparation case-context page. The primary workspace is grouped into
 * task-oriented tabs while the right rail keeps persistent case snapshot context visible.
 */
@Component({
  selector: "phms-case-context-page",
  standalone: true,
  imports: [
    CommonModule,
    UiLibraryModule,
    CaseContextSnapshotRailComponent,
  ],
  templateUrl: "./case-context-page.component.html",
  styleUrl: "./case-context-page.component.scss",
})
export class CaseContextPageComponent implements OnInit, OnChanges, OnDestroy {
  private readonly detailNav = inject(PhmsDetailNavBarService);

  @Input({ required: true }) incarceratedPersonId!: number;
  readonly caseContextTabs = signal<TabConfig[]>([]);

  ngOnInit(): void {
    this.detailNav.show();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["incarceratedPersonId"]) {
      this.caseContextTabs.set(this.buildTabs(this.incarceratedPersonId));
    }
  }

  ngOnDestroy(): void {
    this.detailNav.clear();
  }

  private buildTabs(incarceratedPersonId: number): TabConfig[] {
    const inputs = { incarceratedPersonId };

    return [
      {
        label: "Records & History",
        fragment: "case-records",
        component: CaseContextLegalRecordsTabComponent,
        inputs,
      },
      {
        label: "Documents",
        fragment: "documents",
        component: CaseContextDocumentsTabComponent,
        inputs,
      },
      {
        label: "Activity",
        fragment: "activity",
        component: CaseContextActivityTabComponent,
        inputs,
      },
    ];
  }
}
